var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnAInsight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99978 24.2681H15.5111L18.8447 16.0293L25.2745 31.7074L28.3707 24.2681H33.882",
    stroke: "#172664",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8429 13.5488V13.5498C30.3669 14.8272 31.3611 15.8553 32.6202 16.4219L32.6222 16.4229L33.2413 16.6982L32.5773 16.9932L32.5753 16.9941C31.3473 17.545 30.3697 18.5359 29.8361 19.7715L29.6583 20.1816L29.4796 19.7715C28.9454 18.5362 27.9686 17.5454 26.7404 16.9951H26.7394L26.0734 16.6973L26.6935 16.4229L26.6954 16.4219C27.9549 15.8558 28.9483 14.8271 29.4728 13.5498L29.6583 13.1035L29.8429 13.5488Z",
    stroke: "#172664",
    strokeWidth: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnAInsight);
export default __webpack_public_path__ + "static/media/btn_AInsight.9e7f909bfc3cbb697013106e1142d5ba.svg";
export { ForwardRef as ReactComponent };